import { Fragment, useRef, useEffect } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import addParagraph from "../../../assets/images/model/add_paragraph.svg";
import dragDrop from "../../../assets/images/model/drag_drop.svg";
import dimond from "../../../assets/images/greyled-activity.svg";
import BlockComponent from "../../../components/BlockComponent";
import Section from "./Section";
import { useSelector } from "react-redux";
import OutlineElement from "../../../components/OutlineElement";

const Chapter = (props) => {
  const { loaders } = useSelector((state) => state.ui);
  const chapterRef = useRef(null);
  const sectionRefs = useRef({});
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target.dataset.sectionOrder) {
            // This is a section element
            props.onVisibilityChange(
              props.chap?.order,
              parseInt(entry.target.dataset.sectionOrder)
            );
          } else if (entry.isIntersecting) {
            // This is the chapter element itself
            props.onVisibilityChange(props.chap?.order, null);
          }
        });
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -30% 0px"
      }
    );

    // Observe chapter element
    if (chapterRef.current) observer.observe(chapterRef.current);

    // Observe all sections
    Object.values(sectionRefs.current).forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      if (chapterRef.current) observer.unobserve(chapterRef.current);
      Object.values(sectionRefs.current).forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, [props.chap]);

  const stripFontTags = (html) => {
    return html.replace(/<font[^>]*>/g, "").replace(/<\/font>/g, "");
  };
  return (
    <Draggable draggableId={`chapter_${props.chapInd}`} index={props.chapInd}>
      {(provided) => (
        <div
          className={`book chapter_element book_center_fold ${
            props.highlightedSection === props.chap._id ||
            props.greyedItem === props.chap._id
              ? "highlighted"
              : ""
          }
          ${
            props.draggedOver &&
            props.draggedOver.type === "chapter" &&
            (props.draggedOver.index === props.chap._id ||
              props.draggedOver.index === props.chap._id + "_top")
              ? "trigger"
              : ""
          }`}
          data-id={props.chapInd}
          style={{
            fontFamily: props.chap.fontFamily || "Inter"
          }}
          key={props.chapInd}
          id={props.chap._id}
          onDragLeave={props.handleDragLeave}
          onDrop={(e) => {
            props.handleChapterDrop(e, props.chap, props.chapInd);
          }}
          ref={provided.innerRef}
          {...provided.draggableProps}>
          <div ref={chapterRef}>
            {loaders?.bookLoader ? (
              <div className="chap-load">
                <div
                  className="content-skeleton mb-0 inner-head-load"
                  style={{
                    height: "58px",
                    width: "64%",
                    borderRadius: "4px"
                  }}></div>
                <div
                  className="content-skeleton mb-0 inner-head-load"
                  style={{
                    height: "29px",
                    width: "94%",
                    borderRadius: "4px"
                  }}></div>
              </div>
            ) : (
              <>
                <hr className="activity-line" />
                <div
                  className={`parent_subtitle ${
                    props.draggedOver &&
                    props.draggedOver.type === "chapter" &&
                    props.draggedOver.index === props.chap._id
                      ? "unused_trigger"
                      : ""
                  }`}
                  style={{ alignItems: "start" }}>
                  <div className="create_subtitle">
                    <img
                      className="block-adder"
                      style={{
                        marginRight: "0.5rem",
                        cursor: "pointer"
                      }}
                      src={addParagraph}
                      alt="section paragraph"
                      onClick={() => {
                        props.setShowBlock(props.chap._id);
                      }}
                    />
                    <img
                      src={dragDrop}
                      alt=""
                      style={{
                        cursor: "grab"
                      }}
                      {...provided.dragHandleProps}
                    />
                  </div>
                  {/* Add Block */}
                  {props.showBlock === props.chap._id && (
                    <BlockComponent
                      {...props}
                      setShowBlock={props.setShowBlock}
                      handleChapterDelete={props.handleChapterDelete}
                      blockId={props.chap._id} // chapter ID
                      blockType="chapter" // Specify it's a chapter
                      chapIndex={props.chapInd} // chapter index
                      handleAddChapter={props.handleAddChapter}
                    />
                  )}
                  {/* .................. */}
                  <div
                    className="main-text"
                    onDragOver={(e) => {
                      props.handleDragOver(
                        e,
                        props.chap._id + "_top",
                        props.chap._id + "_top",
                        "",
                        "",
                        "chapter"
                      );
                    }}>
                    <div // contentEditable={true}
                      className={` chapter_element editable-element max_550`}
                      style={{
                        fontSize: "32px",
                        fontWeight: "700",
                        fontFamily: props.chap.fontFamily || "Inter"
                      }}
                      onClick={(e) =>
                        props.setEditableElement(e, {
                          parentElement: "chapter",
                          elementId: props.chap._id,
                          field: "title",
                          chapInd: props.chapInd
                        })
                      }
                      data-id={props.chap._id}
                      dangerouslySetInnerHTML={{
                        __html: stripFontTags(props.chap.title)
                      }}></div>
                    <p // contentEditable={true}
                      className={
                        props.fontLarge
                          ? "theme_para_se chapter_element editable-element fontLarge"
                          : "theme_para_se chapter_element editable-element"
                      }
                      data-id={props.chap._id}
                      onClick={(e) =>
                        props.setEditableElement(e, {
                          parentElement: "chapter",
                          elementId: props.chap._id,
                          field: "description",
                          chapInd: props.chapInd
                        })
                      }
                      dangerouslySetInnerHTML={{
                        __html: props.chap.description
                      }}></p>
                  </div>
                  <div style={{ width: "24px" }}>
                    {props.book.activities.findIndex(
                      (e) => e.chapter === props.chap._id && !e.section
                    ) > -1 && (
                      <Fragment>
                        <img
                          src={dimond}
                          alt="diamond"
                          className="cursor"
                          onClick={(e) => {
                            e.stopPropagation();
                            props.setHighlightedParagraph(null);
                            props.setHighlightedIndexes([]);
                            props.setGreyedPharagraphs([]);
                            props.setDraggedOver(null);
                            props.highlightChapter(e, `${props.chap._id}`);
                          }}
                          style={{
                            alignSelf: "flex-start"
                          }}
                        />
                      </Fragment>
                    )}
                  </div>
                </div>
              </>
            )}
            <div
              className={
                props.draggedOverElement === props.chap._id + "_top"
                  ? "dragged_indicator"
                  : "dragged_indicator_transparent"
              }
              id="indicator"></div>
            <Droppable droppableId={`sections_${props.chapInd}`} type="section">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={snapshot.isDraggingOver ? "is-dragging" : ""}
                  style={{ minHeight: "40px" }}
                  onDragOver={(e) => {
                    props.handleDragOver(
                      e,
                      props.chap._id,
                      props.chap._id,
                      "",
                      "",
                      "chapter"
                    );
                  }}>
                  {props.highlightedIndexes.length > 0 &&
                    props.draggedChap?.split(".")?.[0] ===
                      `${props.chap._id}` &&
                    props?.isSections && (
                      <OutlineElement
                        top={props.pTop}
                        height={props.outlineHeight}
                        resizingSet={props.resizingSet}
                        isResizing={props.isResizing}
                        isErrored={props.isErrored}
                      />
                    )}

                  {props.chap.sections.map((section, secIndex) => (
                    <Section
                      key={`sections_${props.chapInd}_${secIndex}`}
                      {...props}
                      {...{ section, secIndex }}
                      ref={(el) => (sectionRefs.current[section.order] = el)}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            {props.draggedOverElement === props.chap._id &&
              (props.draggedType === "chapter" ||
                props.draggedType === "section") && (
                <div
                  style={{
                    height: 0
                  }}
                  id="dragged_indicator"></div>
              )}
            <div
              className={
                props.draggedOverElement === props.chap._id &&
                (props.draggedType === "chapter" ||
                  props.draggedType === "section")
                  ? "dragged_indicator"
                  : "dragged_indicator_transparent"
              }
              id="indicator"></div>
          </div>
        </div>
      )}
    </Draggable>
  );
};
export default Chapter;
